<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>流程模板</el-breadcrumb-item>
      <el-breadcrumb-item>编辑步骤</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="panel">
      <div class="timeline">
        <!-- Timeline header -->
        <div
          class="timeline-entry"
          v-for="(nodes, x) in nodeGroups"
          v-bind:key="x"
        >
          <div class="timeline-stat">
            <div class="timeline-icon"></div>
            <div class="timeline-time">步骤 {{ x + 1 }}</div>
          </div>
          <div class="timeline-label">
            <div class="nodes">
              <div
                class="flow-node"
                v-for="(node, y) in nodes"
                v-bind:key="node.id"
              >
                <div class="node-header">
                  <div class="title">{{ node.title }}</div>
                  <div @click="deleteNode(node, y)">
                    <i class="ti-trash"></i>
                  </div>
                  <div @click="editNode(node, x, y)">
                    <i class="ti-pencil-alt"></i>
                  </div>
                </div>
                <div class="node-content">
                  <div>{{ modeString(node.mode) }}</div>
                </div>
              </div>
              <div
                class="flow-node btn-primary node-new"
                @click="newNodeAtStep(x)"
              >
                <i class="ti-plus"></i>新加工序
              </div>
            </div>
          </div>
        </div>
        <div class="timeline-entry">
          <div class="timeline-stat">
            <div class="timeline-icon"></div>
            <div class="timeline-time">步骤 {{ nodeGroups.length + 1 }}</div>
          </div>
          <div class="timeline-label">
            <div
              class="flow-node btn-primary node-new"
              @click="newNodeAtStep(nodeGroups.length)"
            >
              <i class="ti-plus"></i>新加工序
            </div>
          </div>
        </div>
      </div>
    </div>
    <node-editor
      :flowId="flowId"
      :step="targetStep"
      :nodeid="editNodeId"
      v-on:created="newNode"
      v-on:updated="updateNode"
    ></node-editor>
  </div>
</template>

<script>
import nodeEditor from '@/views/produce/flow/node_editor'
import { flowTemplateDetail, delFlowNode } from '@/service/getData'

export default {
  components: {
    nodeEditor,
  },
  data() {
    return {
      nodeGroups: [],
      targetStep: 1,
      flowName: '',
      flowId: parseInt(this.$route.query.flowId),
      editNodeId: null,
      editX: -1,
      editY: -1,
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    let _this = this
    $('#NodeEditor').on('hidden.bs.modal', function () {
      _this.editNodeId = null
    })
  },
  methods: {
    initData() {
      this.requestTemplate()
    },
    async requestTemplate() {
      let res = await flowTemplateDetail({
        flowId: this.flowId,
      })

      this.flowName = res.data.name
      let nodes = res.data.nodes
      var nodeMap = {}
      var maxStep = 1
      nodes.map((item) => {
        let index = item.step
        if (!this.nodeGroups[index]) {
          this.$set(this.nodeGroups, index, [])
        }
        this.nodeGroups[index].push(item)
      })
    },
    newNodeAtStep(step) {
      this.targetStep = step
      $('#NodeEditor').modal('show')
    },
    deleteNode(node, index) {
      let that = this
      let step = node.step

      this.$confirm('确认删除工序' + node.title + '？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          delFlowNode({
            id: node.id,
          }).then((res) => {
            if (res.code == 0) {
              var tmp = that.nodeGroups[step]
              tmp.splice(index, 1)
              that.$set(that.nodeGroups, step, tmp)
              that.$message({
                duration: 1000,
                message: '删除成功！',
                type: 'success',
              })
            }
          })
        })
        .catch(() => {})
    },
    editNode(node, x, y) {
      this.editNodeId = node.id
      this.editX = x
      this.editY = y
      $('#NodeEditor').modal('show')
    },
    newNode(node) {
      var step = node.step
      if (!this.nodeGroups[step]) {
        this.nodeGroups[step] = []
      }

      this.$message({
        duration: 1000,
        message: '添加成功！',
        type: 'success',
      })

      var tmp = this.nodeGroups[step]
      tmp.push(node)
      this.$set(this.nodeGroups, step, tmp)
    },
    updateNode(node) {
      let array = this.nodeGroups[this.editX]
      array[this.editY] = node
      this.$set(this.nodeGroups, this.editX, array)
      this.editNodeId = null
      this.editX = -1
      this.editY = -1
    },
    modeString(mode) {
      if (mode == 1) {
        return '手动分配'
      } else if (mode == 2) {
        return '按角色自动分配'
      } else if (mode == 3) {
        return '按人员自动分配'
      } else if (mode == 4) {
        return '按角色抢单'
      } else if (mode == 5) {
        return '按人员抢单'
      }
    },
  },
}
</script>

<style scoped>
.flow-node {
  width: 180px;
  height: auto;
  min-height: 68px;
  padding: 10px;
  background-color: #fff;
  border-radius: 2px;
  padding-bottom: 40px;
  position: relative;
  margin: 5px;
}
.node-header {
  display: flex;
  justify-content: space-around;
}

.node-header .title {
  flex: 1;
  font-weight: bold;
  margin-right: 10px;
  color: #0391d1;
}

.node-header .ti-trash {
  margin-right: 10px;
  color: #bbb;
}

.node-content {
  height: 40px;
  position: absolute;
  bottom: 0;
  line-height: 40px;
}

.nodes {
  display: flex;
  flex-wrap: wrap;
}

.node-new {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 10px;
  font-size: 14px;
  cursor: pointer;
  color: #294f75;
  border-color: #03a9f8 !important;
  cursor: pointer;
}
.node-new i {
  margin-right: 5px;
}
</style>